/**
 * Absolute CMS collection URL for the fullscreen close control.
 *
 * FireCMS `buildUrlCollectionPath("destinations")` returns `c/destinations` with no
 * leading slash. `navigate("c/destinations")` is relative to the nested `/c` route,
 * which resolves to `/c/c/destinations` (page not found).
 */

export function collectionDataPath(collectionIdOrPath: string): string {
  const trimmed = String(collectionIdOrPath ?? "").replace(/^\/+|\/+$/g, "");
  if (!trimmed) return "";
  if (trimmed === "c") return "";
  if (trimmed.startsWith("c/")) return trimmed.slice(2);
  return trimmed;
}

export function fullscreenCloseUrl(
  buildUrlCollectionPath: (path: string) => string,
  collectionIdOrPath: string,
): string {
  const dataPath = collectionDataPath(collectionIdOrPath);
  const built = String(buildUrlCollectionPath(dataPath) ?? "").trim();
  if (!built) return "/c";
  return built.startsWith("/") ? built : `/${built}`;
}
